import { useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import CropVariableForm from "components/agro/cropVariables/CropVariableForm";
import demoCropVariables from "config/demo/cropVariables.json";

const CropVariableUpdateForm = ({ cropVariableId, onSuccess }) => {
  const [cropVariable] = useState(
    demoCropVariables.find((item) => item.id === cropVariableId)
  );

  async function onSubmit(valuesParam) {
    if (onSuccess) onSuccess();
  }

  if (!cropVariable) return <Loader />;

  return (
    <div>
      <CropVariableForm
        onSubmit={onSubmit}
        type="update"
        initialValues={cropVariable}
      />
    </div>
  );
};

export default CropVariableUpdateForm;
